module.exports = window['yo-element-ui'];